import { render, staticRenderFns } from "./createmaill.vue?vue&type=template&id=832cb57c&scoped=true&"
import script from "./createmaill.vue?vue&type=script&lang=js&"
export * from "./createmaill.vue?vue&type=script&lang=js&"
import style0 from "./createmaill.vue?vue&type=style&index=0&id=832cb57c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832cb57c",
  null
  
)

export default component.exports